import { OPEN_PLAYER_CHAMPIONSHIP_POPUP, CLOSE_PLAYER_CHAMPIONSHIP_POPUP } from "../actions";

export const initialState = {
	show: false,
	championship: null,
	contextParams: null,
	playerId: null,
};

export type PlayerChampionshipModalState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_PLAYER_CHAMPIONSHIP_POPUP: {
			return {
				show: true,
				championship: action.championship,
				playerId: action.playerId,
				contextParams: {
					backAction: action.backAction,
					infoAction: action.infoAction,
				},
			};
		}

		case CLOSE_PLAYER_CHAMPIONSHIP_POPUP: {
			return { ...state, show: false, contextParams: null };
		}

		case "@@router/LOCATION_CHANGE": {
			return { ...state, show: false, selectedProfileId: null };
		}

		default:
			return state;
	}
}
